module.exports = __webpack_public_path__ + "img/riverty.a7e3fe1.svg";